import { render } from "./Message.vue?vue&type=template&id=0b0b9435&scoped=true&ts=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=0b0b9435&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0b9435"]])

export default __exports__